/* RANTY · Movimiento. Aparicion al hacer scroll + rebote del contador del carro. Valores desde variables CSS --rm-*. */
(function () {
  var d = document, r = d.documentElement, cs = getComputedStyle(r);
  window.__rmReady = 1;
  function num(n, f) { var v = parseFloat(cs.getPropertyValue(n)); return isNaN(v) ? f : v; }

  /* Rebote del contador del carro (solo cambia una clase del globo; no toca el header) */
  function bump() {
    var host = d.getElementById('cart-icon-bubble');
    if (!r.classList.contains('rm-hover') || !host || !window.MutationObserver) return;
    function count() { var s = host.querySelector('.cart-count-bubble span'); return s ? s.textContent : ''; }
    var last = count();
    new MutationObserver(function () {
      var n = count(); if (n === last) return; last = n;
      var b = host.querySelector('.cart-count-bubble'); if (!b) return;
      b.classList.remove('rm-bump'); void b.offsetWidth; b.classList.add('rm-bump');
      setTimeout(function () { b.classList.remove('rm-bump'); }, 600);
    }).observe(host, { childList: true, subtree: true, characterData: true });
  }

  /* Aparicion al hacer scroll */
  function reveal() {
    if (!r.classList.contains('rm-on') || !('IntersectionObserver' in window)) return;
    var SEL = '.rcc-head,.rcc-tile,.rcc-pcard,.rcc-split__text,.rcc-split__media,.rcc-host,.rcc-occ__card,.rcc-trust__item,.rcc-faq__desc,.rcc-faq__list details,.footer-block,#product-grid>li,.rco__grid>li,.rcb,.rcd__frame,.rgi,.rgb__box,.ranty-same__header,.ranty-same__card,.ranty-crosssell-items,#judgeme_product_reviews,.jdgm-rev-widg';
    var EXC = '.shopify-section-header,.shopify-section-group-header-group,.header-wrapper,cart-drawer,.drawer,.announcement-bar,#shopify-section-announcement-bar';
    var dur = num('--rm-dur', 600), stg = num('--rm-stagger', 70);
    var io = new IntersectionObserver(function (es) {
      var hit = es.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
      hit.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
      hit.forEach(function (el, i) { show(el, i); });
      hit.forEach(spread);
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

    function show(el, i) {
      if (el.classList.contains('rm-in')) return;
      var delay = Math.min(i, 8) * stg;
      io.unobserve(el);
      el.style.transitionDelay = delay + 'ms';
      el.classList.add('rm-in');
      setTimeout(function () { el.classList.remove('rm-reveal', 'rm-in'); el.style.transitionDelay = ''; }, dur + delay + 80);
    }
    /* En carruseles horizontales se revelan todos juntos para que no aparezcan "a trompicones" al deslizar */
    function spread(el) {
      var p = el.parentElement;
      if (!p || p.scrollWidth <= p.clientWidth + 4) return;
      Array.prototype.forEach.call(p.children, function (s) { if (s.classList.contains('rm-reveal')) show(s, 0); });
    }
    function scan(root) {
      if (!root || root.nodeType !== 1) return;
      var list = root.matches && root.matches(SEL) ? [root] : [];
      list = list.concat([].slice.call(root.querySelectorAll(SEL)));
      var vh = window.innerHeight;
      list.forEach(function (el) {
        if (el.__rm || el.closest(EXC)) return;
        var b = el.getBoundingClientRect();
        if ((b.width === 0 && b.height === 0) || b.top < vh) return; /* visible o arriba del pliegue: no se toca */
        el.__rm = 1; el.classList.add('rm-reveal'); io.observe(el);
      });
    }
    scan(d.body);
    var q = [], t = 0;
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { [].forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1) q.push(n); }); });
      if (q.length && !t) t = requestAnimationFrame(function () { t = 0; var n = q; q = []; n.forEach(scan); });
    }).observe(d.body, { childList: true, subtree: true });
    d.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  }

  function init() { bump(); reveal(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();